export var DEFAULT_OFFER_REMAINING = 0;
export var DEFAULT_REMOVE_ITEM_REMAINING_AMOUNTS = [];